import React, { Component } from 'react';
import axios from 'axios';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { parse } from 'qs';
import store from '../../store';
import { GetEmailTemplate } from './Template';
import { GetPdfTemplate } from './Attachment';
import Status from './Status';
import Copy from './copy';

const language = store.getState().content.language;
const type = parse(window.location.search.replace('?', '')).type;
const locale = `${language.replace('-', '_')}${type ? '_' + type : ''}`;
const copy = Copy[locale];

// Form to be wrapped into Formik below
class Form extends Component {
  render() {
    const {
      values,
      touched,
      errors,
      dirty,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      status,
      disabled,
    } = this.props;
    return (
      <form className="email-form" onSubmit={handleSubmit}>
        {status && (
          <Status status={status}>
            {/* {status === 'sending' && <img src='../images/loader.gif' alt='...' />} */}
            {copy.messages[status]}
          </Status>
        )}
        <div className="input__wrapper">
          <input
            id="email"
            autoComplete="email"
            placeholder={copy.inputs.email.label}
            type="text"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.email && touched.email ? 'text-input error' : 'text-input'}
          />
          {errors.email && touched.email && <div className="feedback">{errors.email}</div>}
        </div>
        <button
          className="button"
          type="submit"
          disabled={
            isSubmitting || errors.name || errors.email || errors.cc_email || !dirty || disabled
          }
        >
          {copy.cta}
        </button>
      </form>
    );
  }
}

const EmailForm = withFormik({
  mapPropsToValues: (props) => ({
    email: copy.inputs.email.default,
    onFormSubmit: props.onFormSubmit,
    copy: copy.email,
    basket: props.basket,
  }),
  validationSchema: Yup.lazy(() => {
    return Yup.object().shape({
      email: Yup.string()
        .email(copy.inputs.email.error.invalid)
        .required(copy.inputs.email.error.missing),
    });
  }),
  handleSubmit: (values, { setSubmitting, setStatus }) => {
    const results = store.getState().content.results;
    const emailBody = GetEmailTemplate(values);
    const pdfBody = GetPdfTemplate(results, copy.email.asset_path, language);
    setStatus('sending');
    axios
      .request({
        url: 'https://emailfolioapi.dps.mobil.com/sendemail',
        method: 'post',
        headers: {
          'content-type': 'application/json',
        },
        data: {
          FromText: copy.email.from_text,
          SendTo: values.email,
          SendCc: '',
          Subject: copy.email.subject,
          EmailBody: emailBody,
          PdfBody: pdfBody,
          PdfFilename: copy.email.pdf_filename,
          PublicKey: '352dc81e-70d8-4720-96a8-2078148426bc',
          PdfOrientation: 'portrait',
        },
      })
      .then(() => {
        setSubmitting(false);
        setStatus('sent');
      })
      .catch(() => {
        setSubmitting(false);
        setStatus('failed');
      });
  },
  displayName: 'EmailForm', // helps with React DevTools
})(Form);

export default EmailForm;



// WEBPACK FOOTER //
// ./src/components/EmailForm/index.js